import script from "./WhyUsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyUsSection.vue?vue&type=script&setup=true&lang=js"

import "./WhyUsSection.vue?vue&type=style&index=0&id=0bfe745c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfe745c"]])

export default __exports__